module.exports = __webpack_public_path__ + "img/img_23.7522d5e8.png";